import URL from 'url';
import qs from 'qs';

export default {
    getParameters() {
        let p = qs.parse(URL.parse(decodeURI(location.href)).query);
        return p;
    },
    getParameter(name) {
        let p = qs.parse(URL.parse(decodeURI(location.href)).query);

        return p[name]
    },
    getURL() {
        return URL.parse(decodeURI(location.href))
    }
}